import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui';
import { async } from 'q';
// axios.defaults.timeout = 5000 // 超时默认设置
// axios.defaults.baseURL = apiUrl.baseURL // 默认baseUR
// // axios.defaults.responseType = 'json' // 默认数据相应类型
//  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.withCredentials = true // 表示跨域请求时是否需要使用凭证
let proEnv = require('../../config/pro.env');  // 生产环境

const env = process.env.NODE_ENV;
let target = '';
if(env==='production'){  // 生产环境
  target = proEnv.hosturl;
}else{  // 本地环境
  target = '/'
}
console.log(target,env)
axios.create({
  withCredentials: true,
   baseURL: target, // 'http://192.168.50.135:8085', // 'http://47.111.167.52:8085', // http://47.111.167.52:8085', // 'http://192.168.50.135:8085', // process.env.BASE_API,
  timeout: 60000, // 请求超时时间

})
axios.defaults.baseURL = target
async function request(method, url, params,nomsg,nopage) {  //暴露 request 给我们好API 管理
//  let token = JSON.parse(window.sessionStorage.getItem('token')).token
 let routera =  router.currentRoute.path
 console.log(routera)
 let token  =''
 
 if(routera !== '/'){
  // eslint-disable-next-line no-console
   token= JSON.parse(window.sessionStorage.getItem('token')).token
  //  params = new params
  params.token =token
  if (params.asas !== undefined) {
    delete params.asas;
  }
  // if (nopage ==='page') {
    
  // } else{
  //   if(params.page != undefined ){
  //     console.log(params.page)
  //     if( window.sessionStorage.getItem('page') != undefined ){
  //       params.page =window.sessionStorage.getItem('page')
  //     } 
  //   }
  // }


 console.log(token,params)
  
 }
 
  method = method.toLocaleLowerCase()   //封装RESTful API的各种请求方式 以 post get delete为例
  return new Promise((resolve,reject) => {
   
    axios({
          method: method,
          url,
          params:params   //axios的post 默认转化为json格式
        }).then(res =>{
          res.data.page = params.page
          // window.sessionStorage.removeItem('page')
           
         if(nomsg === 'no'){
          if (res.data.data.content  == '') {
        
            params.page = params.page-1
            axios({
              method: method,
              url,
              params:params   //axios的post 默认转化为json格式
            }).then(res =>{
              return resolve(res) 
            })
         
          }else{
            return resolve(res) 
          }
         }else if (nomsg ==='o') {
          return resolve(res) 
         }
         else{
          Message.success({message:res.data.msg,center: true})
          return resolve(res) 
         }
         
        })
    
       
  }
  )
  
}
export default request
// export default (url, data = {}, type = 'GET') => {
//   type = type.toUpperCase()

//   /*
//       get 方法封装
//       @param url
//       @param data
//       @returns {Promise}
//     */
//   if (type === 'GET') {
//     return new Promise((resolve, reject) => {
//       axios.get(url, {params: data})
//         .then(res => {
//           res = res.data
//           if (res.code === 200) {
//             resolve(res.data)
//           } else {
//             reject(res.data)
//           }
//         }, err => {
//           console.log(err)
//           reject(err)
//         })
//     })
//   }
//   /*
//     post 方法封装
//     @param url
//     @param data
//     @returns {Promise}
//   */
  // if (type === 'POST') {
  //   return new Promise((resolve, reject) => {
  //     axios.post(url, qs.stringify(data))
  //       .then(res => {
  //         res = res.data
  //         if (res.code === 200) {
  //           resolve(res.data)
  //         } else {
  //           reject(res.data)
  //         }
  //       }, err => {
  //         reject(err)
  //       })
  //   })
  // }
// }
